import { DicomProcessor } from '../domain/services/dicomProcessor';
import { ViewManager } from './view/ViewManager';

/**
 * Reference to {@link WebGL2RenderingContext}.\
 * This global context is used by all the components that need to access the {@link WebGL2RenderingContext WebGLContext}.\
 * This context is connected to the {@link ViewManager ViewManager}'s {@link ViewManager.canvas OffscreenCanvas}
 */
export let gl: WebGL2RenderingContext;

/**
 * Method to initialize the engine. This sets up the ViewManager and {@link WebGL2RenderingContext WebGLContext}.
 * @param element An {@link HTMLElement element} that defines the initial dimensions of the {@link ViewManager.canvas OffscreenCanvas}.
 */
export function initializeEngine(
    dp: DicomProcessor,
    element: HTMLElement
): ViewManager;

/**
 * Method to initialize the engine. This sets up the ViewManager and {@link WebGL2RenderingContext WebGLContext}.
 * @param width The initial width of the {@link ViewManager.canvas OffscreenCanvas}.
 * @param height The initial height of the {@link ViewManager.canvas OffscreenCanvas}.
 */
export function initializeEngine(
    dp: DicomProcessor,
    width: number,
    height: number
): ViewManager;

export function initializeEngine(
    dp: DicomProcessor,
    arg0: HTMLElement | number,
    height?: number
): ViewManager {
    let singletons: [ViewManager, WebGL2RenderingContext];
    if (arg0 instanceof HTMLElement) {
        singletons = ViewManager.initializeViewManager(dp, arg0);
    } else {
        singletons = ViewManager.initializeViewManager(
            dp,
            arg0,
            height as number
        );
    }
    gl = singletons[1];

    //TODO: Make actual use of these. Recommend the user to change to a dedicated/discrete GPU if possible.
    const debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
    if (debugInfo) {
        // eslint-disable-next-line no-console
        console.log(gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL));
        // eslint-disable-next-line no-console
        console.log(gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL));
    }
    return singletons[0];
}

// allow mocking the gl context for testing
export function setGl(glContext: WebGL2RenderingContext): void {
    gl = glContext;
}
